<template>
  <main class="document-templates">
    <div class="document-templates__body">
      <h1>Шаблоны документов</h1>
      <div class="document-templates__controls">
        <input-text-search
          class="document-templates__search"
          v-bind:value="searchQuery"
          v-on:input="onInputSearchQuery"
          placeholder="Введите название документа"
        />
        <button
          class="document-templates__button-add"
          type="button"
          v-on:click="onClickAddTemplate">Добавить</button>
      </div>
      <div v-if="hasCategories">
        <div class="document-templates__tables-container">
          <div class="document-templates__categories">
            <div class="document-templates__categories__caption">
              <span>Категории</span>
            </div>
            <div class="document-templates__categories__container">
              <category-item
                v-for="category in categories"
                v-bind:has-delete="true"
                v-bind:has-edit="true"
                v-bind:key="category.id"
                v-bind:selected-category="selectedCategoryId"
                v-bind:category="category"
                v-on:select-category="onSelectCategory"
                v-on:delete-category="onShowDeleteCategoryForm"
                v-on:edit-category="onShowEditCategoryForm"
              />
            </div>
          </div>
          <div class="document-templates__table">
            <div class="document-templates__table__head">
              <div class="document-templates__table__cell">
                №
              </div>
              <div class="document-templates__table__cell">
                Название документа
              </div>
              <div class="document-templates__table__cell">
                Тип документа
              </div>
              <div class="document-templates__table__cell" />
            </div>
            <div
              class="document-templates__table__row"
              v-bind:key="index"
              v-for="(template, index) in templates"
            >
              <div class="document-templates__table__cell">{{ index + 1 }}</div>
              <div class="document-templates__table__cell">{{ template.getNameWithPrefix() }}</div>
              <div class="document-templates__table__cell">{{ template.typeName }}</div>
              <div class="document-templates__table__cell">
                <button
                  class="document-templates__table-row-edit"
                  title="Изменить шаблон"
                  type="button"
                  v-if="!template.isSample"
                  v-on:click="onClickTemplateEditButton(template)" />
              </div>
              <div class="document-templates__table__cell">
                <button
                  class="document-templates__table-row-remove"
                  title="Удалить шаблон"
                  type="button"
                  v-if="template.isCanBeRemoved"
                  v-on:click="onTemplateRemove(template.removingId, template.typeName)" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <support-contacts
        v-if="!isAwaitRequest && !hasCategories"
        class="document-templates__support"
        v-bind:title="titleSupportContacts"
        v-bind:is-show-mini-button-whats-app="true"
        v-bind:is-show-large-button-whats-app="false"
      />
    </div>
    <modal-dialog
      v-bind:title="templateRemoveTitle"
      v-bind:value="hasTemplateRemovalConfirmation"
      v-bind:with-cross="true"
      v-on:input="onTemplateRemovalConfirmationInput"
    >
      <div class="document-template-removal">
        <button
          class="document-template-removal__cancel"
          type="button"
          v-on:click="onTemplateRemovalConfirmationInput"
        >Отмена</button>
        <button
          class="document-template-removal__confirm"
          type="button"
          v-if="templateRemoveResolve"
          v-on:click="templateRemoveResolve"
        >Удалить</button>
      </div>
    </modal-dialog>
    <modal-dialog
      title="Вы точно хотите удалить категорию?"
      v-bind:value="isShowDeleteCategoryDialog"
      v-bind:with-cross="true"
    >
      <confirm-modal
        confirm-title="Удалить"
        cancel-title="Отмена"
        v-on:on-confirm="deleteCategory(selectedDeleteCategoryId)"
        v-on:on-cancel="isShowDeleteCategoryDialog = false"
      />
    </modal-dialog>
    <confirm-side-dialog
      v-bind:label="'Добавить'"
      v-bind:with-cross="true"
      v-if="isShowCreateForm"
      v-on:cancel="isShowCreateForm = false"
    >
      <form-document-template-item
        v-bind:categories="categories"
        v-bind:input-errors="inputErrors"
        v-on:on-download="onDownloadFile"
        v-on:on-create-category="createCategory"
        v-on:on-create-document-template="createDocumentTemplate"
        v-on:on-create-contract-template="createContractTemplate"
        v-on:on-preview-contract="previewContractTemplate"
        v-on:on-preview-document="previewDocumentTemplate"
        v-on:on-download-variables="downloadVariables"
        v-on:on-cancel="isShowCreateForm = false"
      />
    </confirm-side-dialog>
    <confirm-side-dialog
      v-bind:label="'Редактирование категории'"
      v-bind:with-cross="true"
      v-if="isShowFormEditCategory"
      v-on:cancel="isShowFormEditCategory = false"
    >
      <form-document-template-category-edit
        v-bind:input-errors="inputErrors"
        v-bind:initial-id="selectedCategoryForEdit.id"
        v-bind:initial-name="selectedCategoryForEdit.name"
        v-on:on-submit="editCategory"
        v-on:on-cancel="isShowFormEditCategory = false"
      />
    </confirm-side-dialog>
    <confirm-side-dialog
      v-bind:label="'Редактирование документа'"
      v-bind:with-cross="true"
      v-if="isShowEditTemplateSidebar"
      v-on:cancel="isShowEditTemplateSidebar = false">
      <form-edit-clinic-document-template
        v-bind:input-errors="inputErrors"
        v-bind:initial-template="selectedEditTemplate"
        v-bind:categories="categories"
        v-on:cancel="isShowEditTemplateSidebar = false"
        v-on:submit-document="editDocumentTemplate"
        v-on:submit-contract="editContractTemplate"
        v-on:preview-contract="previewContractTemplate"
        v-on:preview-document="previewDocumentTemplate"
        v-on:download-file="onDownloadFile"
        v-on:download-variables="downloadVariables"
      />
    </confirm-side-dialog>
  </main>
</template>

<script>
import InputTextSearch from '@/components/InputTextSearch.vue';
import ModalDialog from '@/components/ModalDialog.vue';
import SupportContacts from '@/components/SupportContacts.vue';
import debounce from 'lodash.debounce';
import notifierMixin from '@/mixins/notifierMixin';
import { List } from 'monet';
import ConfirmSideDialog from '@/components/ConfirmSideDialog.vue';
import FormEditClinicDocumentTemplate from '@/components/FormEditClinicDocumentTemplate.vue';
import { CONTRACT_TYPE, DOCUMENT_TYPE } from '@/mixins/clinicTemplateMixin';
import CategoryItem from '@/components/CategoryItem.vue';
import FormDocumentTemplateItem from '@/components/FormDocumentTemplateItem.vue';
import FormDocumentTemplateCategoryEdit from '@/components/FormDocumentTemplateCategoryEdit.vue';
import ConfirmModal from '@/components/ConfirmModal.vue';

/**
 * @description Сохранить файл.
 * @param file
 * @param name
 */
function saveFile(file, name) {
  const obj = URL.createObjectURL(file);
  const link = document.createElement('a');
  link.href = obj;
  link.target = '_blank';
  link.download = name;
  link.click();
  URL.revokeObjectURL(link.href);
  link.remove();
}

export default {
  components: {
    ConfirmModal,
    FormDocumentTemplateCategoryEdit,
    FormDocumentTemplateItem,
    CategoryItem,
    FormEditClinicDocumentTemplate,
    ConfirmSideDialog,
    InputTextSearch,
    ModalDialog,
    SupportContacts,
  },
  computed: {
    /**
     * @description Имеются категории.
     * @type {boolean}
     */
    hasCategories() {
      return this.categories.length > 0;
    },
    /**
     * @description Имеет подтверждение для удаления шаблона.
     */
    hasTemplateRemovalConfirmation() {
      return this.templateRemoveResolve !== null;
    },
  },
  async created() {
    await this.fetchCategories();
    this.fetchTemplatesByFirstCategory();
  },
  data() {
    return {
      /**
       * @description Показывать ли диалоговое окно удаления категории.
       * @type {boolean}
       */
      isShowDeleteCategoryDialog: false,
      /**
       * @description Редактируемая категория.
       * @type {Object}
       */
      selectedCategoryForEdit: null,
      /**
       * @description Выбранная категория для удаления.
       * @type {String}
       */
      selectedDeleteCategoryId: '',
      /**
       * @description Показывать ли форму редактирования категории.
       * @type {boolean}
       */
      isShowFormEditCategory: false,
      /**
       * @description Выбранная категория шаблона лечения
       * @type {string}
       */
      selectedCategoryId: '',
      /**
       * @description Категории
       * @type Array
       */
      categories: [],
      /**
       * @description Показывать ли сайдбар редактирования шаблона.
       * @type {Boolean}
       */
      isShowEditTemplateSidebar: false,
      /**
       * @description Выбранный шаблон на редактирование.
       * @type {Template}
       */
      selectedEditTemplate: null,
      /**
       * @description Показывать ли сайдбар создания шаблона.
       * @type {Boolean}
       */
      isShowCreateForm: false,
      /**
       * @description Разрешение удаления шаблона.
       * @type {(function|null)}
       */
      templateRemoveResolve: null,
      /**
       * @description Заголовок удаления шаблона.
       * @type {string}
       */
      templateRemoveTitle: '',
      /**
       * @description Список шаблонов.
       * @type {List<Template>}
       */
      templates: List(),
      /**
       * @description Ожидание завершения запроса.
       * @type {boolean}
       */
      isAwaitRequest: false,
      /**
       * @description Нарушения ограничений.
       * @type {any}
       */
      inputErrors: {},
      /**
       * @description Заголовок блока контактов поддержки.
       * @type {string}
       */
      titleSupportContacts: 'Для автозаполнения и скачивания документов отправьте нам шаблоны '
          + 'документов вашей клиники (договор, согласие на обработку персональных данных и т.д.), '
          + 'мы сами загрузим их в МИС. \n\n Ваш менеджер Татьяна',
      searchQuery: '',
    };
  },
  methods: {
    /**
     * @description Затянуть шаблоны из первой категории
     * @returns {void}
     */
    fetchTemplatesByFirstCategory() {
      const categoryId = this.categories[0]?.id;
      if (categoryId) {
        this.onSelectCategory(categoryId);
      }
    },
    /**
     * @description Удалить категорию
     * @param {number} id
     * @returns {void}
     */
    deleteCategory(id) {
      this.isShowDeleteCategoryDialog = false;
      const onSuccess = async (response) => {
        this.notifySuccess(response.title);
        await this.fetchCategories();
        this.fetchTemplatesByFirstCategory();
        this.deleteCategoryDialog = false;
      };
      const onFail = (response) => {
        this.notifyFail(response.getTitle());
        this.inputErrors = response.allCauses();
      };
      this
        .$documentTemplateGateway
        .deleteDocumentCategory(id)
        .then((result) => {
          result.fold(onFail, onSuccess);
        })
        .finally(() => {
          this.isAwaitRequest = false;
        });
    },
    /**
     * @description Создать категорию.
     * @param {DocumentCategoryCreateRequest} request
     * @returns {void}
     */
    createCategory(request) {
      const onSuccess = async (response) => {
        this.notifySuccess(response.title);
        await this.fetchCategories();
        this.onSelectCategory(response.id);
        this.isShowCreateForm = false;
      };
      const onFail = (response) => {
        this.notifyFail(response.getTitle());
        this.inputErrors = response.allCauses();
      };
      this
        .$documentTemplateGateway
        .createDocumentCategory(request)
        .then((result) => {
          result.fold(onFail, onSuccess);
        })
        .finally(() => {
          this.isAwaitRequest = false;
        });
    },
    /**
     * @description Обработать события показа формы редактирования категории.
     * @param id
     * @returns {void}
     */
    onShowEditCategoryForm(id) {
      this.selectedCategoryForEdit = this.categories.find((el) => el.id === id);
      this.inputErrors = {};
      this.isShowFormEditCategory = true;
    },

    /**
     * @description Обработать событие выбора категории.
     * @param id
     * @returns {void}
     */
    onSelectCategory(id) {
      this.selectedCategoryId = id;
      this.fetchTemplates(id);
    },

    /**
     * @description Сохранить изменённую категорию.
     * @param {DocumentCategoryEditRequest} request
     * @returns {void}
     */
    editCategory(request) {
      const onSuccess = (response) => {
        this.notifySuccess(response.title);
        this.fetchCategories();
        this.isShowFormEditCategory = false;
      };
      const onFail = (response) => {
        this.notifyFail(response.getTitle());
        this.inputErrors = response.allCauses();
      };
      this
        .$documentTemplateGateway
        .editDocumentCategory(request)
        .then((result) => {
          result.fold(onFail, onSuccess);
        })
        .finally(() => {
          this.isAwaitRequest = false;
        });
    },
    /**
     * @description Затянуть категории.
     * @returns {void}
     */
    async fetchCategories() {
      this.isAwaitRequest = true;
      const onSuccess = (response) => {
        this.categories = response.data;
      };
      const onFail = (response) => {
        this.notifyFail(response.getTitle());
        this.inputErrors = response.allCauses();
      };
      await this
        .$documentTemplateGateway
        .getDocumentCategories()
        .then((result) => {
          result.fold(onFail, onSuccess);
        })
        .finally(() => {
          this.isAwaitRequest = false;
        });
    },
    /**
     * @description Отобразить диалог удаления категории.
     * @param {Number} categoryId
     * @returns {void}
     */
    onShowDeleteCategoryForm(categoryId) {
      this.selectedDeleteCategoryId = categoryId;
      this.isShowDeleteCategoryDialog = true;
    },
    /**
     * @description Скачать файл с переменными.
     * @returns {void}
     */
    downloadVariables() {
      const onSuccess = (response) => {
        saveFile(response, 'Переменные.docx');
      };
      const onFail = (response) => {
        this.notifyFail(response.getTitle());
      };
      this
        .$documentTemplateGateway
        .downloadTemplateVariables()
        .then((result) => {
          result.fold(onFail, onSuccess);
        })
        .finally(() => {
          this.isAwaitRequest = false;
        });
    },
    /**
     * @description Редактирование шаблона документа.
     * @param request {ClinicTemplateRequestEdit}
     * @returns {void}
     */
    editDocumentTemplate(request) {
      const onSuccess = (response) => {
        this.notifySuccess(response.message);
        this.onSelectCategory(request.getCategoryId());
        this.isShowEditTemplateSidebar = false;
      };
      const onFail = (response) => {
        this.notifyFail(response.getTitle());
        this.inputErrors = response.allCauses();
      };
      this
        .$documentTemplateGateway
        .editClinicDocumentTemplate(request)
        .then((result) => {
          result.fold(onFail, onSuccess);
        })
        .finally(() => {
          this.isAwaitRequest = false;
        });
    },
    /**
     * @description Создание шаблона документа.
     * @param request {ClinicTemplateRequestPreview}
     * @returns {void}
     */
    previewDocumentTemplate(request) {
      const onSuccess = (response) => {
        window.open(URL.createObjectURL(response), '_blank');
      };
      const onFail = (response) => {
        this.notifyFail(response.getTitle());
        this.inputErrors = response.allCauses();
      };
      this
        .$documentTemplateGateway
        .previewClinicDocumentTemplate(request)
        .then((result) => {
          result.fold(onFail, onSuccess);
        })
        .finally(() => {
          this.isAwaitRequest = false;
        });
    },
    /**
     * @description Создание шаблона документа.
     * @param request {ClinicTemplateRequestPreview}
     * @returns {void}
     */
    previewContractTemplate(request) {
      const onSuccess = (response) => {
        window.open(URL.createObjectURL(response), '_blank');
      };
      const onFail = (response) => {
        this.notifyFail(response.getTitle());
        this.inputErrors = response.allCauses();
      };
      this
        .$documentTemplateGateway
        .previewClinicContractTemplate(request)
        .then((result) => {
          result.fold(onFail, onSuccess);
        })
        .finally(() => {
          this.isAwaitRequest = false;
        });
    },
    /**
     * @description Редактировать шаблона документа.
     * @param request {ClinicTemplateRequestEdit}
     * @returns {void}
     */
    editContractTemplate(request) {
      const onSuccess = (response) => {
        this.notifySuccess(response.message);
        this.onSelectCategory(request.getCategoryId());
        this.isShowEditTemplateSidebar = false;
      };
      const onFail = (response) => {
        this.notifyFail(response.getTitle());
        this.inputErrors = response.allCauses();
      };
      this
        .$documentTemplateGateway
        .editClinicContractTemplate(request)
        .then((result) => {
          result.fold(onFail, onSuccess);
        })
        .finally(() => {
          this.isAwaitRequest = false;
        });
    },

    /**
     * @description Создание шаблона документа.
     * @param request {ClinicTemplateRequestCreate}
     * @returns {void}
     */
    createDocumentTemplate(request) {
      const onSuccess = (response) => {
        this.notifySuccess(response.message);
        this.onSelectCategory(request.getCategoryId());
        this.isShowCreateForm = false;
      };
      const onFail = (response) => {
        this.notifyFail(response.getTitle());
        this.inputErrors = response.allCauses();
      };
      this
        .$documentTemplateGateway
        .storeClinicDocumentTemplate(request)
        .then((result) => {
          result.fold(onFail, onSuccess);
        })
        .finally(() => {
          this.isAwaitRequest = false;
        });
    },
    /**
     * @description Создание шаблона договора.
     * @param request {ClinicTemplateRequestCreate}
     * @returns {void}
     */
    createContractTemplate(request) {
      const onSuccess = (response) => {
        this.notifySuccess(response.message);
        this.onSelectCategory(request.getCategoryId());
        this.isShowCreateForm = false;
      };
      const onFail = (response) => {
        this.notifyFail(response.getTitle());
        this.inputErrors = response.allCauses();
      };
      this
        .$documentTemplateGateway
        .storeClinicContractTemplate(request)
        .then((result) => {
          result.fold(onFail, onSuccess);
        })
        .finally(() => {
          this.isAwaitRequest = false;
        });
    },
    /**
     * @description Обработать событие нажатия на кнопку добавления шаблона.
     * @returns {void}
     */
    onClickAddTemplate() {
      this.inputErrors = {};
      this.isShowCreateForm = true;
    },
    /**
     * @description Обработать ввод запроса.
     * @type {string} value
     * @returns {void}
     */
    onInputSearchQuery(value) {
      this.searchQuery = value;
    },
    /**
     * @description Обработать ввод диалога подтверждения при удалении шаблона.
     * @param {boolean} value Значение.
     * @returns {void}
     */
    onTemplateRemovalConfirmationInput(value) {
      if (value !== true) {
        this.templateRemoveResolve = null;
        this.templateRemoveTitle = '';
      }
    },
    /**
     * @description Обработать событие нажатия на кнопку редактирования шаблона.
     * @param {Template} template
     */
    onClickTemplateEditButton(template) {
      this.selectedEditTemplate = template;
      this.inputErrors = {};
      this.isShowEditTemplateSidebar = true;
    },
    /**
     * @description Обработать удаление шаблона.
     * @param {string} templateId Идентификатор шаблона.
     * @param {string} type       Тип шаблона.
     * @returns {void}
     */
    onTemplateRemove(templateId, type) {
      (new Promise((resolve) => {
        this.templateRemoveResolve = () => resolve(templateId);
        this.templateRemoveTitle = `Вы точно хотите удалить ${type}?`;
      }))
        .then((confirmedTemplateId) => {
          this.$documentTemplateGateway.deleteTemplate(confirmedTemplateId).then((result) => {
            result.forEachLeft(({ title }) => {
              this.notifyFail(title);
            });
            result.forEach(({ title }) => {
              this.fetchTemplates();
              this.notifySuccess(title);
            });
          });
        })
        .finally(() => {
          this.templateRemoveResolve = null;
          this.templateRemoveTitle = '';
        });
    },
    /**
     * @description Получить список шаблонов.
     * @returns {void}
     */
    fetchTemplates() {
      this.isAwaitRequest = true;
      this.$documentTemplateGateway.viewList(this.searchQuery, this.selectedCategoryId)
        .then((result) => {
          result.forEach((list) => {
            this.templates = List.fromArray(list);
          });
          result.forEachLeft((error) => {
            this.notifyFail(error.title);
          });
          this.isAwaitRequest = false;
        });
    },
    /**
     * @description Обработать событие загрузки файла.
     *
     * @param {Object} request
     *
     * @returns {void}
     */
    onDownloadFile(request) {
      const { file, type } = request;
      if (file) {
        this.downloadExistFile(file.id, file.name, type);
      }
      saveFile(request, request.name);
    },
    /**
     * @description Скачать существующий файл
     * @param id
     * @param name
     * @param type
     * @returns {void}
     */
    downloadExistFile(id, name, type) {
      if (type === DOCUMENT_TYPE) {
        this.downloadDocument(id, name);
      }
      if (type === CONTRACT_TYPE) {
        this.downloadContract(id, name);
      }
    },
    /**
     * @description Скачать документ
     * @param id
     * @param name
     * @returns {void}
     */
    downloadDocument(id, name) {
      const onSuccess = (response) => {
        saveFile(response, name);
      };
      const onFail = (response) => {
        this.notifyFail(response.getTitle());
        this.inputErrors = response.allCauses();
      };
      this
        .$documentTemplateGateway
        .downloadClinicDocumentTemplate(id)
        .then((result) => {
          result.fold(onFail, onSuccess);
        })
        .finally(() => {
          this.isAwaitRequest = false;
        });
    },
    /**
     * @description Загрузить договор.
     * @param id
     * @param name
     * @returns {void}
     */
    downloadContract(id, name) {
      const onSuccess = (response) => {
        saveFile(response, name);
      };
      const onFail = (response) => {
        this.notifyFail(response.getTitle());
        this.inputErrors = response.allCauses();
      };
      this
        .$documentTemplateGateway
        .downloadClinicContractTemplate(id)
        .then((result) => {
          result.fold(onFail, onSuccess);
        })
        .finally(() => {
          this.isAwaitRequest = false;
        });
    },
  },
  mixins: [
    notifierMixin,
  ],
  name: 'ClinicPanelClinicDocumentTemplateList',
  watch: {
    searchQuery: {
      handler: debounce(async function _() {
        await this.fetchTemplates();
      }, 300),
    },
  },
};
</script>

<style lang="scss">
@use "@/scss/buttons";

.document-template-removal {
  display: flex;
  flex-direction: row;
  gap: .75rem;
  & &__cancel,
  & &__confirm {
    @include buttons.btn-transparent(10rem, 2rem, 1rem);
  }
  & &__confirm,
  & &__confirm:hover {
    border: 1px solid var(--warning-color);
    color: var(--warning-color);
  }
}

.document-templates {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  &__controls {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    gap: 10px 25px;
  }
  &__button-add {
    @include buttons.btn-blue(225px, 48px, 16px);
    @include buttons.btn-blue-add(19px);
    max-width: 100%;
    height: 50px;
  }
  &__body {
    display: grid;
    gap: 2rem;
    padding: 38px 20px 48px 23px;
    width: 100%;
    overflow-y: auto;
    overflow-x: hidden;
  }
  &__search {
    max-width: 515px;
    margin-bottom: 20px;
  }
  &__tables-container {
    display: grid;
    grid-template-columns: 280px 1fr;
    gap: 10px;
  }
  &__categories {
    width: 280px;
    &__caption {
      font-size: 14px;
      line-height: 17px;
      font-weight: 700;
      border-bottom: 2px solid #0489e0;
      padding: 6px 10px 14px;
    }
    &__container {
      display: flex;
      flex-direction: column;
      gap: 15px;
      width: 280px;
      background: #f2f7fa;
      padding: 20px 10px;
    }
  }
  &__table {
    counter-reset: counterEmployees;
    overflow-x: auto;
    &:empty {
      display: none;
    }
    &__head,
    &__row {
      display: grid;
      grid-template-columns: 60px 1fr 1fr 43px 43px;
      grid-gap: 4px;
      align-items: center;
      min-width: 800px;
      font-size: 14px;
      line-height: 17px;
    }
    &__row {
      width: 100%;
    }
    &__head {
      font-weight: 700;
      border-bottom: 2px solid #0489e0;
      padding: 10px 0;
    }
    &__row {
      border-bottom: 1px solid #eaeff3;
      padding: 12px 0;
    }
    &__cell {
      text-align: left;
      padding: 0 8px;
    }
  }
  &__table-row-remove {
    @include buttons.btn-cross-remove(100%);
  }
  &__table-row-edit {
    @include buttons.btn-pen-edit(100%);
  }
  &__support {
    background-color: transparent !important;
    padding: 0 !important;
    .support-contacts__caption,
    .support-contacts__tel,
    .support-contacts__email {
      font-size: 16px;
      line-height: 25px;
    }
    .support-contacts__button {
      font-size: 16px;
    }
  }
}
</style>
